import api from './apiClient';

const CACHE_DURATION = 30 * 1000; // 30 segundos para actividades
const STATS_CACHE_DURATION = 5 * 60 * 1000; // 5 minutos para estadísticas

const isCacheValid = (timestamp, duration) => {
  if (!timestamp) return false;
  const now = Date.now();
  return (now - parseInt(timestamp)) < duration;
};

export const getActivityLogs = async (filters = {}, ignoreCache = false) => {
  try {
    const cacheKey = `activities_${JSON.stringify(filters)}`;
    const cachedData = localStorage.getItem(cacheKey);
    const cacheTimestamp = localStorage.getItem(`${cacheKey}_timestamp`);

    if (!ignoreCache && cachedData && isCacheValid(cacheTimestamp, CACHE_DURATION)) {
      return JSON.parse(cachedData);
    }

    const params = new URLSearchParams(filters);
    const response = await api.get(`/activity-logs/?${params}`);
    
    localStorage.setItem(cacheKey, JSON.stringify(response));
    localStorage.setItem(`${cacheKey}_timestamp`, Date.now().toString());
    
    return response;
  } catch (error) {
    console.error('Error fetching activities:', error);
    throw error;
  }
};

export const getActivityStats = async (ignoreCache = false) => {
  try {
    const cachedStats = localStorage.getItem('activity_stats');
    const cacheTimestamp = localStorage.getItem('activity_stats_timestamp');

    if (!ignoreCache && cachedStats && isCacheValid(cacheTimestamp, STATS_CACHE_DURATION)) {
      return JSON.parse(cachedStats);
    }

    const response = await api.get('/activity-logs/stats/');
    
    localStorage.setItem('activity_stats', JSON.stringify(response));
    localStorage.setItem('activity_stats_timestamp', Date.now().toString());
    
    return response;
  } catch (error) {
    console.error('Error fetching activity stats:', error);
    throw error;
  }
};

export const clearActivityCache = () => {
  // Limpiar todas las claves de caché que empiecen con 'activities_'
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('activities_') || key === 'activity_stats') {
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}_timestamp`);
    }
  });
};
